import React from 'react';
import { Empty } from 'antd';
import CampaignAgentStatsPage from '../../pages/CampaignAgentStatsPage';
import WindowNote from './WindowNote';

/**
 * The agent breakdown for the campaign, rendered by the page that already computes it.
 *
 * Not a reimplementation: the Campaign Summary is a hub, so this scopes the
 * existing page to the chosen campaign rather than growing a second query for
 * the same numbers. A fix to that page lands here too, and the two cannot
 * drift into disagreeing.
 *
 * Keyed on CXCampaignNo, not the app's Campaigns.ID -- the campaign-stats
 * endpoints take the CX number.
 */
export default function AgentsTab({ campaign, from, to, skills }) {
  const cx = campaign?.CXCampaignNo;
  if (!cx) {
    return (
      <Empty
        description="This campaign has no CX campaign number, so call data cannot be looked up for it"
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        style={{ marginTop: 40 }}
      />
    );
  }
  return (
    <>
      <WindowNote from={from} to={to} />
    <CampaignAgentStatsPage
      embedded
      filters={{ campaign: String(cx), start_date: from, end_date: to, ...(skills ? { skill: skills.join(',') } : {}) }}
    />
    </>
  );
}
